import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/data/content";
import { SectionHeading } from "./PriceMenu";

export const FAQ = () => (
  <section id="faq" data-testid="faq-section" className="mx-auto max-w-4xl px-6 py-24 lg:px-10 lg:py-32">
    <SectionHeading eyebrow="Good to Know" title="Frequently Asked Questions" testId="faq-heading" />

    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, delay: 0.15 }}
      className="mt-14"
    >
      <Accordion type="single" collapsible className="space-y-4">
        {FAQS.map((f, i) => (
          <AccordionItem
            key={f.q}
            value={`faq-${i}`}
            data-testid={`faq-item-${i}`}
            className="rounded-sm border border-[#D4AF37]/20 bg-[#FFFFFF]/60 px-6 backdrop-blur-xl transition-colors duration-300 data-[state=open]:border-[#D4AF37]/50"
          >
            <AccordionTrigger
              data-testid={`faq-trigger-${i}`}
              className="py-5 text-left font-display text-lg text-[#1B3A6B] hover:text-[#D4AF37] hover:no-underline"
            >
              {f.q}
            </AccordionTrigger>
            <AccordionContent data-testid={`faq-content-${i}`} className="pb-6 text-sm leading-relaxed text-[#67718A]">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </motion.div>
  </section>
);
